module.exports = __webpack_public_path__ + "img/banner3.fa12244d.png";